import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/basc_logo.png'
import _imports_1 from '../assets/batc_logo.png'


const _hoisted_1 = { class: "w-full text-center mb-5" }
const _hoisted_2 = { class: "pt-10 px-10 flex justify-center align-middle" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "pt-10 px-10 flex justify-center align-middle" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_router_link, {
        to: "BASC",
        class: "hpbutton"
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: "nes-btn huVjiU cZIuQT mr-5",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
          }, "Baby Apes Quests")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _createVNode(_component_router_link, {
        to: "BATC",
        class: "hpbutton"
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: "nes-btn huVjiU cZIuQT mr-5",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
          }, "Baby Tiger Quests")
        ]),
        _: 1
      })
    ])
  ]))
}